import {
  AbstractBundleDataStream,
  EditableDataStreamInterface,
  KeyTypeType,
  RawBundleType,
} from '../../utility/editable-data-stream';

export class VirtualBundle<
  DataType,
  KeyType extends KeyTypeType,
> extends AbstractBundleDataStream<DataType> {
  constructor(
    public id: KeyType,
    variables: Record<
      keyof DataType,
      EditableDataStreamInterface<
        DataType[keyof DataType],
        Uint8Array,
        keyof DataType
      >
    >,
  ) {
    super(variables);
  }

  async readRawInner(): Promise<RawBundleType<DataType>> {
    const output: Partial<RawBundleType<DataType>> = {};
    for (const v of this.variables) {
      output[v.id] = await v.readRaw();
    }
    return output as RawBundleType<DataType>;
  }
}
